var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.resp.length > 0),expression:"resp.length > 0"}],staticClass:"alert",class:_vm.retval== 'OK' ? 'alert-success' : 'alert-danger',attrs:{"role":"alert"}},[_c('ul',_vm._l((_vm.resp),function(item){return _c('li',[_vm._v(_vm._s(item.msg))])}),0)])])
}
var staticRenderFns = []

export { render, staticRenderFns }